import { defineStyle, ComponentStyleConfig } from '@chakra-ui/react';

// // // Defina o estilo do "ring"
const ringCss = defineStyle({
  outlineWidth: '1px',
  outlineColor: 'brand.500',
  outlineOffset: '0px',
  outlineStyle: 'solid',
});

// Defina os estilos base
const baseStyle = {
  container: {
    ...ringCss,
    // borderRadius: 'full', // Certifica que o Avatar é circular
  },
  // badge: {
  //   borderWidth: '1px', // Ajuste de estilo para o badge (se usado)
  //   borderColor: 'brand',
  // },
};

export const avatar: ComponentStyleConfig = {
  baseStyle, // Estilo base
  // sizes: {
  //   sm: {
  //     container: {
  //       boxSize: '30px',
  //     },
  //   },
  //   md: {
  //     container: {
  //       boxSize: '40px',
  //     },
  //   },
  //   lg: {
  //     container: {
  //       boxSize: '50px',
  //     },
  //   },
  // },
  // variants: {
  //   solid: {
  //     container: {
  //       bgColor: 'brand',
  //       color: 'brand',
  //     },
  //   },
  //   outline: {
  //     container: {
  //       borderWidth: '1px',
  //       borderColor: 'black',
  //     },
  //   },
  // },
  defaultProps: {
    size: 'md',
    // variant: 'outline',
  },
};
